export default "__VITE_ASSET__DxJCkQ0T__"